import { render, staticRenderFns } from "./AddOfficialAc.vue?vue&type=template&id=89c2c9d4&scoped=true&"
import script from "./AddOfficialAc.vue?vue&type=script&lang=js&"
export * from "./AddOfficialAc.vue?vue&type=script&lang=js&"
import style0 from "./AddOfficialAc.vue?vue&type=style&index=0&id=89c2c9d4&lang=less&scoped=true&"
import style1 from "./AddOfficialAc.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c2c9d4",
  null
  
)

export default component.exports